// Generated by CoffeeScript 2.4.1
(function() {
  // Libs
  var SocketController, SocketControllerWithStream, ss;

  SocketController = require('./SocketController');

  ss = require('socket.io-stream');

  SocketControllerWithStream = class SocketControllerWithStream extends SocketController {
    requireIO() {
      return require('socket.io-client');
    }

    parseBody(body) {
      if (body.type !== 'STREAM') {
        return JSON.stringify(body);
      } else {
        return body;
      }
    }

    getSocket(body) {
      if (body.type !== 'STREAM') {
        return this.io;
      } else {
        return ss(this.io);
      }
    }

    createStream() {
      return ss.createStream();
    }

    STREAM(path, body) {
      return this.emit(path, body);
    }

  };

  module.exports = SocketControllerWithStream;

}).call(this);
